import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconSortNewest({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M2 4a.5.5 0 0 1 0-1h12a.5.5 0 0 1 0 1H2zm0 4.5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1H2zm-.5 4a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1H2a.5.5 0 0 0-.5.5zm10.346.36a.5.5 0 0 1-.692 0l-2.5-2.4a.5.5 0 0 1 .692-.72L11 11.326V6.5a.5.5 0 0 1 1 0v4.827l1.654-1.588a.5.5 0 0 1 .692.722l-2.5 2.4z"/>
        </svg>
    );
}

export default IconSortNewest;
